import React, { useCallback, useState } from 'react'
import { Formik, useFormikContext } from 'formik'
import { useDispatch } from 'react-redux'
import { Row } from 'react-bootstrap'
import { _, withCapture } from 'utils'
import ConfirmModal from 'components/ConfirmModal'
import FullPageLoading from 'components/FullPageLoading'
import { useEventSlug } from 'hooks'
import TextField from '../forms/components/TextField'
import DateField from '../forms/components/DateField'
import TimeField from '../forms/components/TimeField'
import { showNotification } from '../notifications'
import { showErrorNotification } from '../notifications/notificationsSlice'
import { createGroupSession } from './graphql/mutation'
import { GroupSessionValidation } from './GroupSessionEditor'

interface CreateGroupSessionProps {
  close: () => void
  onSubmitted: () => void
}

interface CreateGroupSessionModalProps {
  close: () => void
}

const CreateGroupSessionForm = () => (
    <>
        <Row>
            <TextField name="title" label={_('groupsession.form.title')} isRequired />
        </Row>
        <Row>
            <DateField
                name="startsAt"
                label={_('groupsession.form.start_date')}
                lg={1/2}
                isRequired
            />
            <TimeField
                name="startsAt"
                label={_('groupsession.form.start_time')}
                lg={1/2}
                isRequired
            />
        </Row>
        <Row>
            <DateField
                name="endsAt"
                label={_('groupsession.form.end_date')}
                lg={1/2}
                isRequired
            />
            <TimeField
                name="endsAt"
                label={_('groupsession.form.end_time')}
                lg={1/2}
                isRequired
            />
        </Row>
    </>
)

const CreateGroupSessionModal = ({ close }: CreateGroupSessionModalProps) => {
    const { submitForm, isValid } = useFormikContext()
    return (
        <>
            <ConfirmModal
                close={close}
                title={_('groupsession.create_dialog.title')}
                confirmDescription={<CreateGroupSessionForm />}
                confirmText={_('groupsession.create_dialog.create')}
                disabledConfirm={!isValid}
                onBeforeConfirm={submitForm}
                variantConfirm="success"
            />
        </>
    )
}

const CreateGroupSession = ({ close, onSubmitted }: CreateGroupSessionProps) => {
    const eventSlug = useEventSlug()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const handleSubmit = useCallback(async ({ title, endsAt, startsAt }) => {
        setLoading(true)
        const response = await withCapture(async () => await createGroupSession({
            title,
            eventId: eventSlug,
            endsAt,
            startsAt,
        }))()
        setLoading(false)

        if (response?.data) {
            dispatch(showNotification({
                type: 'success',
                body: _('form.notification.update_success'),
            }))
            onSubmitted?.()
            return true
        }

        dispatch(showErrorNotification(response?.errors))
        return false
    }, [dispatch, eventSlug, onSubmitted])

    return (
        <Formik
            initialValues={{ title: '', startsAt: '', endsAt: '' }}
            validateOnMount
            validationSchema={GroupSessionValidation}
            onSubmit={handleSubmit}
        >
            <>
                <CreateGroupSessionModal close={close} />
                {loading && <FullPageLoading isAbsolute fullWidth />}
            </>

        </Formik>
    )
}

export default CreateGroupSession
